<button class="ui button product-wizard-back-button" (click)="onClick($event)">
  <img width="32" height="32" [src]="'icons/arrow-left-black.svg' | assetsPath | async" />
  <ng-container *ngIf="!(isMobile$ | async)">
    {{ text }}
  </ng-container>
</button>
